import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import DesktopView from './desktop-view';
import LowResolutionView from '../common/low-resolution-view';

export default function Main({
  contributorCount,
  partnership,
  investorTypes,
  mobileImageUrl,
}) {
  const { isLowResolution } = React.useContext(ThemeContext);

  return isLowResolution
    ? <LowResolutionView type="audience" mobileImageUrl={mobileImageUrl} />
    : (
      <DesktopView {...{
        ...partnership,
        investorTypes,
        contributorCount,
      }}
      />
    );
}

Main.propTypes = {
  partnership: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    cachedAnalyticsDataUrls: PropTypes.shape({
      followersDataUrl: PropTypes.string,
      contributorRankingDataUrl: PropTypes.string,
      investorTypesDataUrl: PropTypes.string,
    }),
    contributors: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string,
      createdAt: PropTypes.string,
    })).isRequired,
  }).isRequired,
  investorTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  contributorCount: PropTypes.number.isRequired,
  mobileImageUrl: PropTypes.string.isRequired,
};
